module.exports = __webpack_public_path__ + "img/32.d8d66d43.jpg";